import React from 'react';
import { documentTypesAPI } from '../api/client';
import LookupMultiSelect from './LookupMultiSelect';

/**
 * Active Document Types -- a document's classification ("Policy", "Procedure",
 * "Job Aid"). GitHub issue #202.
 *
 * Fetches GET /api/document-types/selectable, which is gated on
 * require_identity ALONE rather than document_types.read (issue #22): that
 * resource is non-hierarchical, so .read is satisfiable only org-wide and the
 * admin list endpoint would 403 exactly the scoped readers this filter is for.
 */
function DocumentTypeMultiSelect({ selectedIds, onChange }) {
  return (
    <LookupMultiSelect
      fetchItems={() => documentTypesAPI.getSelectable()}
      selectedIds={selectedIds}
      onChange={onChange}
      placeholder="All document types"
      emptyMessage="No document types defined yet. Add one under Admin → Document Types."
    />
  );
}

export default DocumentTypeMultiSelect;
